import CoachRoutineDaySection from "./CoachRoutineDaySection"
import { getMondayOfWeek } from "../../../util/util"

const CoachRoutine = () => {
  const mondayOfWeek = getMondayOfWeek()
  const daysNumbersOfWeek = Array.from({ length: 7 }).map((_, index) => ({
    day: mondayOfWeek.add(index, "day").format("dddd"),
    number: mondayOfWeek.add(index, "day").format("D"),
    fullDate: mondayOfWeek.add(index, "day").format("YYYY-MM-DD"),
  }))

  return (
    <div className="w-full flex flex-col gap-2 p-6 pb-24">
      {daysNumbersOfWeek?.map((day, index) => (
        <CoachRoutineDaySection
          key={index}
          dayOfWeek={day.day}
          dayNumber={day.number}
          fullDate={day.fullDate}
        />
      ))}
    </div>
  )
}

export default CoachRoutine
